import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ApiService } from 'src/app/shared/service/api.service';
import { CONSTANTS } from 'src/app/constants';

@Component({
  selector: 'app-financial-informative',
  templateUrl: './financial-informative.component.html',
  styleUrls: ['./financial-informative.component.css']
})
export class FinancialInformativeComponent implements OnInit {
  _filterAccomplish: any = {};
  @Input() set filterAccomplish(value: any) {
    this._filterAccomplish = value;
    this.filterItem(this._filterAccomplish);
  }
  @Output() errorEmitter = new EventEmitter();
  
  dataSource: any = {
    chart: {
      numberPrefix: "R$ ",
      theme: "fusion",
      paletteColors: "#005781",
      maxBarHeight: "14",
      showValues: "1",
      placeValuesInside: "0"
    },
    data: []
  }

  itemTotalPagar!: any;
  itemTotalPagarSemana!: any;
  itemTotalPagarMes!: any;
  itemTotalPagarAno!: any;

  itemTotalReceber!: any;
  itemTotalReceberSemana!: any;
  itemTotalReceberMes!: any;
  itemTotalReceberAno!: any;

  itemPrazoPagamento!: any;

  itemPrazoRecebimento!: any;
  
  loadingTotalPagar: boolean = true;
  loadingTotalReceber: boolean = true;
  loadingPrazoPagamento: boolean = true;
  loadingPrazoRecebimento: boolean = true;
  errorApi: boolean = false;
  message : string = "";
  loading: boolean = true;

  constructor(private api: ApiService) { }

  ngOnInit(): void {
    this.clearValues();
  }

  clearValues() {
    this.itemTotalPagar = null;
    this.itemTotalPagarSemana = null;
    this.itemTotalPagarMes = null;
    this.itemTotalPagarAno = null;
    this.itemTotalReceber = null;
    this.itemTotalReceberSemana = null;
    this.itemTotalReceberMes = null;
    this.itemTotalReceberAno = 0;
    this.itemPrazoPagamento = null;
    this.itemPrazoRecebimento = null;
  }

  filterItem(item: any) {
    this.errorApi = false;
    this.loadingTotalPagar = true;
    this.loadingTotalReceber = true;
    this.loadingPrazoPagamento = true;
    this.loadingPrazoRecebimento = true;
    this.financialInformation(item);
  }

  financialInformation(item: any) {
    this.api.postTotalAmountPayable(item.branch).subscribe(data => {
      try {
        let content = data.dataRow;
        this.itemTotalPagar = this.formatNumber(content[0].value_total);
        this.itemTotalPagarSemana = this.formatNumber(content[0].value_week);
        this.itemTotalPagarMes = this.formatNumber(content[0].value_month);
        this.itemTotalPagarAno = this.formatNumber(content[0].value_year);
        this.loadingTotalPagar = false;
      } catch (error : unknown) {
        this.loadingTotalPagar = false;
        if (error instanceof Error)
          this.formatErrorMensagem(error.message);
      }
    }, error => {
      this.loadingTotalPagar = false;
      this.errorApi = true;
      this.message = CONSTANTS.MESSAGES.DATA_ERRO_TOTAL_PAYABLE;
      this.formatErrorMensagem(error.message);
    });

    this.api.postAmountReceivable(item.branch).subscribe(data => {
      try {
        let content = data.dataRow[0];
        this.itemTotalReceber = this.formatNumber(content.value_total);
        this.itemTotalReceberSemana = this.formatNumber(content.value_week);
        this.itemTotalReceberMes = this.formatNumber(content.value_month);
        this.itemTotalReceberAno = this.formatNumber(content.value_year);
        this.loadingTotalReceber = false;
      } catch (error: unknown){
        this.loadingTotalReceber = false;
        if (error instanceof Error)
          this.formatErrorMensagem(error.message);
      }
    }, error => {
      this.loadingTotalReceber = false;
      this.errorApi = true;
      this.message = CONSTANTS.MESSAGES.DATA_ERRO_TOTAL_RECEIVABLE;
      this.formatErrorMensagem(error.message);
    });
    
    new Promise<void>((resolve, reject) => {
      this.api.postAveragePaymentTerm(item.dataMin, item.dataMax, item.branch).subscribe(data => {
        try {
          this.itemPrazoPagamento = data.dataRow[0].average_qty;
          if (data.dataRow[0].average_qty !== null) {
            this.loadingPrazoPagamento = false;
          }
          this.errorApi = false;
          this.loading = false;
        } catch (error : unknown) {
          this.loadingPrazoPagamento = false;
          if (error instanceof Error)
            this.formatErrorMensagem(error.message);
        }
        }, error => {
          this.loadingPrazoPagamento = false;
          this.errorApi = true;
          this.message = CONSTANTS.MESSAGES.DATA_ERRO_AVERAGE_PAYMENT_PERIOD;
          this.formatErrorMensagem(error.message);
        });
      });

    new Promise<void>((resolve, reject) => {
      this.api.postAverageTerm(item.dataMin, item.dataMax, item.branch).subscribe(data => {
        try {
          this.itemPrazoRecebimento = data.dataRow[0].AVAREGE_VALUE;
          if (data.dataRow[0].AVAREGE_VALUE !== null) {
            this.loadingPrazoRecebimento = false;
          }
          this.errorApi = false;
          this.loading = false;
        } catch (error : unknown) {
          this.loadingPrazoRecebimento = false;
          if (error instanceof Error)
            this.formatErrorMensagem(error.message);
        }
        }, error => {
          this.loadingPrazoRecebimento = false;
          this.errorApi = true;
          this.message = CONSTANTS.MESSAGES.DATA_ERRO_AVERAGE_RECEIPT_PERIOD;
          this.formatErrorMensagem(error.message);
        });
      });
  }

  formatErrorMensagem(item: any) {
    let dataError = new Date();
    let errorMensagem = "Arquivo: financial-informative-components \r\n" + "Data: " + dataError + "\r\n" + "Mensagem: " + item + "\r\n" + "===============================================" + "\r\n";
    this.errorEmitter.emit(errorMensagem);
  }


  private formatNumber(value: number): string {
    return parseFloat(value.toString()).toLocaleString('pt-br', {minimumFractionDigits: 2});
  }

}
